export const environment = {
  production: false,
  preProd: false,
  qa: false,
  with_auth_url: 'https://dev-api.solvezy.net/sellerauth',
  without_auth_url: 'https://dev-api.solvezy.net/wauth',
  clientId: '4e15m4p5l9886529mib8t5t1uu',
  matomoURL: 'https://dev-api.solvezy.net/wauth/ma',
  bil_desktop_url: 'https://bil-dev.solvezy.net',
  matomoSiteId: 4,
  trackingApiUrl: "https://appeventsdefault.jumbotail.com/solv-seller-portal"
};


/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.

